let CoinMatchConfig = require("activity/CoinMatchActivity/CoinMatchConfig")
let CoinMatchLogic = require("activity/CoinMatchActivity/CoinMatchLogic")

let CoinMatchResetPanel = xClass("CoinMatchResetPanel", BasePanel, () => {
    return cc.CSLoader.createNode(CoinMatchConfig.reset.csb)
})

CoinMatchResetPanel.preloadResPromise = function(withMask = false) {
    if (CoinMatchConfig.reset.resList.length > 0) {
        return preloadWithLoadingPromise(CoinMatchConfig.reset.resList, withMask);
    } else {
        return Promise.resolve();
    }

}

CoinMatchResetPanel.show = function(onShowSuccess, onShowFail, onPanelClose) {
    CoinMatchResetPanel.preloadResPromise()
        .then(()=> {
            let panel = CoinMatchResetPanel.create();
            panel.popup(true);
            if(onPanelClose != null)
                panel.on(BasePanelEvent.Close, onPanelClose);
            
            if (onShowSuccess != null)  
                onShowSuccess();
        })
        .catch((err)=> {
            console.error("CoinMatchResetPanel show failed.", err);
            LogToLogCenter(err);
            if (onShowFail != null) {
                onShowFail(err);
            }
        });
}

CoinMatchResetPanel.prototype.onEnter = function() {
    BasePanel.prototype.onEnter.call(this);
    this.initUI();
}

CoinMatchResetPanel.prototype.initUI = function() {
    let layout = CoinMatchConfig.reset;

    this.sureBtn = GetChildByPath(this, layout.sureBtn);
    quickBuildBtn(this.sureBtn, UIGLabelButton, PushBounceAnim, 
        ()=> { 
            DCAssist.dc4AdClick("battleForGold", "click_watchAd_reset_btn");
            CoinMatchLogic.reset( ()=> this.onClose() ) 
        }, true); 

    this.closeBtn = GetChildByPath(this, layout.closeBtn);
    quickBuildBtn(this.closeBtn, UIButton, PushBounceAnim, ()=> this.onClose(), true);

    let desc = GetChildByPath(this, layout.txtName);
    desc.setString(CoinMatchConfig.strings.resetTip);


    if (DYAdUtil.isOpen()){ 
        this.sureBtn.setVisible(false)
        let btnConfirm = DYAdUtil.createBtn({
            txt:"确定",
            size: cc.size(220,120),
            type: 1,
        },true,()=>{
            DCAssist.dc4AdClick("battleForGold", "click_watchAd_reset_btn");
            CoinMatchLogic.reset( ()=> this.onClose() )
        });
        btnConfirm.setPosition(cc.p(this.sureBtn.x - 120,this.sureBtn.y))
        this.addChild(btnConfirm);
        
        let btnCancel = DYAdUtil.createBtn({
            txt:"取消",
            size: cc.size(220,120),
            type: 2,
        },false,()=>{
            this.onClose()
        });
        btnCancel.setPosition(cc.p(this.sureBtn.x + 120,this.sureBtn.y))
        this.addChild(btnCancel)
    }
}

CoinMatchResetPanel.prototype.cleanup = function () {
    BasePanel.prototype.cleanup.call(this);
    if (CoinMatchConfig.reset.resList.length > 0)
        ResManager.release(CoinMatchConfig.reset.resList);
}

module.exports = CoinMatchResetPanel